import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import CustomChip from "../CustomComponents/CustomChip/CustomChip";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/Dashboard";
import upIcon from "../../assets/images/up.png";
import downIcon from "../../assets/images/down.png";
import forwardIcon from "../../assets/images/forward.png";
import CustomCircle from "../CustomComponents/CustomCircle/CustomCircle";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import DateTime from "../DateTime/DateTime";
import ArrowUpIcon from "../../assets/images/arrowUp.png";
import ArrowDownIcon from "../../assets/images/arrowDown.png";
import ArrowForwardIcon from "../../assets/images/arrowRight.png";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import { useTheme } from "@material-ui/core/styles";
import {
    getUserData,
    getDate,
    getUserRBAC,
    isShowEventScore,
} from "../../services/LocalStorageService";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import { EntityAccess, EventCode, RBAC_CODE } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function DashboardScoreCard(props) {
    const params = useParams();
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [getRBAC_Score_Card] = React.useState(
        getUserRBAC(RBAC_CODE.SCORE_CARD_VIEW, props)
    );
    const [getRBAC_WOL_View] = React.useState(getUserRBAC(RBAC_CODE.WOL_VIEW, props));
    const [getRBAC_AnalyticsView] = React.useState(
        getUserRBAC(RBAC_CODE.ANALYTICS_VIEW, props)
    );
    const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const {
        praisoScore,
        brakingScore,
        corneringScore,
        speedingScore,
        engagementScore,
        distractionScore,
        accelerationScore,
    } = props;
    const [userData] = React.useState(getUserData);
    const [isApi, setIsApi] = React.useState(false);
    const [isApiFailed, setIsApiFailed] = React.useState(false);
    const dates = getDate();
    const currentStartDate = dates.startDate;
    const currentEndDate = dates.endDate;
    const [isShowSpeeding] = React.useState(isShowEventScore(EventCode.SPEEDING));
    const [isShowBraking] = React.useState(isShowEventScore(EventCode.BRAKING));
    const [isShowCornering] = React.useState(isShowEventScore(EventCode.CORNERING));
    const [isShowDistraction] = React.useState(isShowEventScore(EventCode.DRIVER_DISTRACTION));
    const [isShowAcceleration] = React.useState(isShowEventScore(EventCode.ACCELERATION));
    // const circleSize = isMobile ? 250 : 300;

    React.useEffect(() => {
        setIsApi(props.isApi);
    }, [props.isApi]);

    React.useEffect(() => {
        setIsApiFailed(props.isApiFailed);
    }, [props.isApiFailed]);

    return (
        <CustomPaper square elevation={0} className={classes.height100}>
            <CustomCard
                elevation={0}
                className={clsx(classes.height100, classes.cardContentWrapper)}
            >
                <CustomCardContent className={classes.cardContent}>
                    <CustomGrid container justifyContent="space-between">
                        <CustomTypography
                            className={classes.cardTitle}
                            component="h3"
                            variant="h3"
                        >
                            {/* {i18n.t("AVERAGE_PRAISO_SCORE", {FleetOrDriver: getRBAC_Score_Card &&
                            getRBAC_Score_Card.isGroupScope === EntityAccess.ALLOWED &&
                            getRBAC_Score_Card.isAccessible === EntityAccess.ALLOWED
                                ? t("FLEET")
                                : t("DRIVER")})} */}
                            {getRBAC_Score_Card &&
                                getRBAC_Score_Card.isGroupScope === EntityAccess.ALLOWED &&
                                getRBAC_Score_Card.isAccessible === EntityAccess.ALLOWED
                                ? t("AVERAGE_FLEET_PRAISO_SCORE")
                                : t("AVERAGE_DRIVER_PRAISO_SCORE")}
                        </CustomTypography>
                        <span className={classes.timeText}>
                            <DateTime
                                inputDate={currentStartDate}
                                returnFormat="DD MMM YYYY"
                                className={classes.timeText}
                            />{" "}
                            -{" "}
                            <DateTime
                                inputDate={currentEndDate}
                                returnFormat="DD MMM YYYY"
                                className={classes.timeText}
                            />
                        </span>
                    </CustomGrid>
                    <CustomGrid
                        container
                        className={classes.graphContainer}
                        justifyContent="center"
                        spacing={5}
                    >
                        <CustomGrid item>
                            <div className={classes.scoreDialWrapper}>
                                <CustomCircle
                                    size={300}
                                    // size={circleSize}
                                    className={classes.circleSize}
                                    isApi={props.isApi}
                                    isApiFailed={props.isApiFailed}
                                    score={
                                        praisoScore &&
                                        Math.round((praisoScore.score + Number.EPSILON) * 100) / 100
                                    }
                                />
                                {praisoScore && (
                                    <CustomChip
                                        className={classes.scoreChip}
                                        icon={
                                            praisoScore && praisoScore.scoreTrend === 1 ? (
                                                <img
                                                    height={33}
                                                    alt=""
                                                    src={upIcon}
                                                    // className={classes.upIcon}
                                                    style={{ marginRight: '5px' }}
                                                />
                                            ) : praisoScore && praisoScore.scoreTrend === -1 ? (
                                                <img
                                                    alt=""
                                                    height={33}
                                                    src={downIcon}
                                                    // className={classes.downIcon}
                                                    style={{ marginRight: '5px' }}
                                                />
                                            ) : praisoScore && praisoScore.scoreTrend === 0 ? (
                                                <img
                                                    alt=""
                                                    src={forwardIcon}
                                                    // className={classes.forwardIcon}
                                                    style={{ marginRight: '5px' }}
                                                />
                                            ) : null
                                        }
                                        label={
                                            praisoScore && praisoScore.score !== undefined && praisoScore.score !== null ?
                                                Math.round((praisoScore.score + Number.EPSILON) * 100) /
                                                100 : "N/A"
                                        }
                                    />
                                )}
                                {!isApi && !praisoScore && (
                                    <CustomSkeleton
                                        className={classes.scoreChipSkeleton}
                                        animation="wave"
                                        width={132}
                                        height={64}
                                    /* style={{
                                        position: "absolute",                                        top: "calc(50% - 20px)",
                                        left: "calc(50% - 66px)",
                                        borderRadius: "32px",
                                        transform: "scale(1, 1) !important",
                                    }} */
                                    />
                                )}
                                {isApi && (
                                    <CustomCircularProgress
                                        className={classes.scoreChipLoader}
                                    /* style={{
                                        position: "absolute",
                                        top: "calc(50% - 20px)",
                                        left: "calc(50% - 20px)",
                                    }} */
                                    />
                                )}
                                <div className={classes.cardDate}>
                                    <span>0</span>
                                    <span>100</span>
                                </div>
                            </div>
                        </CustomGrid>
                    </CustomGrid>
                    <CustomGrid
                        container
                        justifyContent="space-between"
                        display="flex"
                        spacing={5}
                        className={classes.trendingScoreList}
                    >
                        {isShowSpeeding && (
                            <CustomGrid item>
                                <div>
                                    <CustomTypography
                                        className={classes.scoreValue}
                                        component="h4"
                                        variant="h4"
                                    >
                                        {speedingScore && speedingScore.scoreTrend === 1 ? (
                                            <img
                                                alt=""
                                                src={ArrowUpIcon}
                                                className={classes.arrowUpIcon}
                                            />
                                        ) : speedingScore && speedingScore.scoreTrend === -1 ? (
                                            <img
                                                alt=""
                                                src={ArrowDownIcon}
                                                className={classes.arrowDownIcon}
                                            />
                                        ) : speedingScore && speedingScore.scoreTrend === 0 ? (
                                            <img
                                                alt=""
                                                src={ArrowForwardIcon}
                                                className={classes.arrowForwardIcon}
                                            />
                                        ) : null}
                                        {isApi || !speedingScore ? (
                                            <CustomSkeleton
                                                className={classes.scoreValueSkeleton}
                                                animation="wave"
                                                width={60}
                                                height={24}
                                            />
                                        ) : speedingScore ? speedingScore.score !== undefined && speedingScore.score !== null ? (
                                            `${Math.round((speedingScore.score + Number.EPSILON) * 100) /
                                            100
                                            }%`
                                        ) : "N/A" : (
                                            "0"
                                        )}
                                    </CustomTypography>
                                    <CustomTypography
                                        className={classes.scoreLabel}
                                        component="span"
                                    >
                                        {t("SPEEDING")}
                                    </CustomTypography>
                                </div>
                            </CustomGrid>
                        )}

                        {isShowBraking && (
                            <CustomGrid item>
                                <div>
                                    <CustomTypography
                                        className={classes.scoreValue}
                                        component="h4"
                                        variant="h4"
                                    >
                                        {brakingScore && brakingScore.scoreTrend === 1 ? (
                                            <img
                                                alt=""
                                                src={ArrowUpIcon}
                                                className={classes.arrowUpIcon}
                                            />
                                        ) : brakingScore && brakingScore.scoreTrend === -1 ? (
                                            <img
                                                alt=""
                                                src={ArrowDownIcon}
                                                className={classes.arrowDownIcon}
                                            />
                                        ) : brakingScore && brakingScore.scoreTrend === 0 ? (
                                            <img
                                                alt=""
                                                src={ArrowForwardIcon}
                                                className={classes.arrowForwardIcon}
                                            />
                                        ) : null}
                                        {isApi || !brakingScore ? (
                                            <CustomSkeleton
                                                className={classes.scoreValueSkeleton}
                                                animation="wave"
                                                width={60}
                                                height={24}
                                            />
                                        ) : brakingScore ? brakingScore.score !== undefined && brakingScore.score !== null ? (
                                            `${Math.round((brakingScore.score + Number.EPSILON) * 100) /
                                            100
                                            }%`
                                        ) : "N/A" : (
                                            "0"
                                        )}
                                    </CustomTypography>
                                    <CustomTypography
                                        className={classes.scoreLabel}
                                        component="span"
                                    >
                                        {t("BRAKING")}
                                    </CustomTypography>
                                </div>
                            </CustomGrid>
                        )}

                        {isShowCornering && (
                            <CustomGrid item>
                                <div>
                                    <CustomTypography
                                        className={classes.scoreValue}
                                        component="h4"
                                        variant="h4"
                                    >
                                        {corneringScore && corneringScore.scoreTrend === 1 ? (
                                            <img
                                                alt=""
                                                src={ArrowUpIcon}
                                                className={classes.arrowUpIcon}
                                            />
                                        ) : corneringScore && corneringScore.scoreTrend === -1 ? (
                                            <img
                                                alt=""
                                                src={ArrowDownIcon}
                                                className={classes.arrowDownIcon}
                                            />
                                        ) : corneringScore && corneringScore.scoreTrend === 0 ? (
                                            <img
                                                alt=""
                                                src={ArrowForwardIcon}
                                                className={classes.arrowForwardIcon}
                                            />
                                        ) : null}
                                        {isApi || !corneringScore ? (
                                            <CustomSkeleton
                                                className={classes.scoreValueSkeleton}
                                                animation="wave"
                                                width={60}
                                                height={24}
                                            />
                                        ) : corneringScore ? corneringScore.score !== undefined && corneringScore.score !== null ? (
                                            `${Math.round(
                                                (corneringScore.score + Number.EPSILON) * 100
                                            ) / 100
                                            }%`
                                        ) : "N/A" : (
                                            "0"
                                        )}
                                    </CustomTypography>
                                    <CustomTypography
                                        className={classes.scoreLabel}
                                        component="span"
                                    >
                                        {t("CORNERING")}
                                    </CustomTypography>
                                </div>
                            </CustomGrid>
                        )}

                        {isShowAcceleration && (
                            <CustomGrid item>
                                <div>
                                    <CustomTypography
                                        className={classes.scoreValue}
                                        component="h4"
                                        variant="h4"
                                    >
                                        {accelerationScore && accelerationScore.scoreTrend === 1 ? (
                                            <img
                                                alt=""
                                                src={ArrowUpIcon}
                                                className={classes.arrowUpIcon}
                                            />
                                        ) : accelerationScore && accelerationScore.scoreTrend === -1 ? (
                                            <img
                                                alt=""
                                                src={ArrowDownIcon}
                                                className={classes.arrowDownIcon}
                                            />
                                        ) : accelerationScore && accelerationScore.scoreTrend === 0 ? (
                                            <img
                                                alt=""
                                                src={ArrowForwardIcon}
                                                className={classes.arrowForwardIcon}
                                            />
                                        ) : null}
                                        {isApi || !accelerationScore ? (
                                            <CustomSkeleton
                                                className={classes.scoreValueSkeleton}
                                                animation="wave"
                                                width={60}
                                                height={24}
                                            />
                                        ) : accelerationScore ? accelerationScore.score !== undefined && accelerationScore.score !== null ? (
                                            `${Math.round(
                                                (accelerationScore.score + Number.EPSILON) * 100
                                            ) / 100
                                            }%`
                                        ) : "N/A" : (
                                            "0"
                                        )}
                                    </CustomTypography>
                                    <CustomTypography
                                        className={classes.scoreLabel}
                                        component="span"
                                    >
                                        {t("ACCELERATION")}
                                    </CustomTypography>
                                </div>
                            </CustomGrid>
                        )}

                        <CustomGrid item>
                            <div>
                                <CustomTypography
                                    className={classes.scoreValue}
                                    component="h4"
                                    variant="h4"
                                >
                                    {engagementScore && engagementScore.scoreTrend === 1 ? (
                                        <img
                                            alt=""
                                            src={ArrowUpIcon}
                                            className={classes.arrowUpIcon}
                                        />
                                    ) : engagementScore && engagementScore.scoreTrend === -1 ? (
                                        <img
                                            alt=""
                                            src={ArrowDownIcon}
                                            className={classes.arrowDownIcon}
                                        />
                                    ) : engagementScore && engagementScore.scoreTrend === 0 ? (
                                        <img
                                            alt=""
                                            src={ArrowForwardIcon}
                                            className={classes.arrowForwardIcon}
                                        />
                                    ) : null}
                                    {isApi || !engagementScore ? (
                                        <CustomSkeleton
                                            className={classes.scoreValueSkeleton}
                                            animation="wave"
                                            width={60}
                                            height={24}
                                        />
                                    ) : engagementScore ? engagementScore.currentScore !== undefined && engagementScore.currentScore !== null ? (
                                        `${Math.round(
                                            (engagementScore.currentScore + Number.EPSILON) * 100
                                        ) / 100
                                        }%`
                                    ) : "N/A" : (
                                        "0"
                                    )}
                                </CustomTypography>
                                <CustomTypography
                                    className={classes.scoreLabel}
                                    component="span"
                                >
                                    {t("ENGAGEMENT")}
                                </CustomTypography>
                            </div>
                        </CustomGrid>

                        {isShowDistraction && (
                            <CustomGrid item>
                                <div>
                                    <CustomTypography
                                        className={classes.scoreValue}
                                        component="h4"
                                        variant="h4"
                                    >
                                        {distractionScore && distractionScore.scoreTrend === 1 ? (
                                            <img
                                                alt=""
                                                src={ArrowUpIcon}
                                                className={classes.arrowUpIcon}
                                            />
                                        ) : distractionScore && distractionScore.scoreTrend === -1 ? (
                                            <img
                                                alt=""
                                                src={ArrowDownIcon}
                                                className={classes.arrowDownIcon}
                                            />
                                        ) : distractionScore && distractionScore.scoreTrend === 0 ? (
                                            <img
                                                alt=""
                                                src={ArrowForwardIcon}
                                                className={classes.arrowForwardIcon}
                                            />
                                        ) : null}
                                        {isApi || !distractionScore ? (
                                            <CustomSkeleton
                                                className={classes.scoreValueSkeleton}
                                                animation="wave"
                                                width={60}
                                                height={24}
                                            />
                                        ) : distractionScore ? distractionScore.score !== undefined && distractionScore.score !== null ? (
                                            `${Math.round(
                                                (distractionScore.score + Number.EPSILON) * 100
                                            ) / 100
                                            }%`
                                        ) : "N/A" : (
                                            "0"
                                        )}
                                    </CustomTypography>
                                    <CustomTypography
                                        className={classes.scoreLabel}
                                        component="span"
                                    >
                                        {t("MOBILE_DISTRACTION")}
                                    </CustomTypography>
                                </div>
                            </CustomGrid>
                        )}

                    </CustomGrid>
                    <CustomGrid
                        container
                        // justifyContent={isMobile ? "center" : "flex-end"}
                        justifyContent={"flex-end"}
                        className={classes.justifyCenter}
                        spacing={0}
                    >
                        <CustomGrid item>
                            <CustomBox component="div" mt={2}>
                                {getRBAC_AnalyticsView &&
                                    getRBAC_AnalyticsView.isAccessible === EntityAccess.ALLOWED ? (
                                    <>
                                        {isApi || isApiFailed || !praisoScore ? (
                                            <CustomTypography
                                                className={classes.viewDetailLinkDisabled}
                                                component="span"
                                            >
                                                {t("VIEW_ANALYTICS")}
                                            </CustomTypography>
                                        ) : (
                                            <CustomLink
                                                className={classes.viewDetailLink}
                                                href={params.impersonationid ? `/impersonation/${params.impersonationid}/analytics` : "/analytics"}
                                            >
                                                {t("VIEW_ANALYTICS")}
                                            </CustomLink>
                                        )}
                                    </>
                                ) : null}
                            </CustomBox>
                        </CustomGrid>
                        {getRBAC_WOL_View &&
                            getRBAC_WOL_View.isAccessible === EntityAccess.ALLOWED &&
                            getRBAC_AnalyticsView &&
                            getRBAC_AnalyticsView.isAccessible === EntityAccess.ALLOWED ? (
                            <CustomGrid item>
                                <CustomBox component="div" mt={2} ml={1} mr={1}>
                                    |
                                </CustomBox>
                            </CustomGrid>
                        ) : null}
                        <CustomGrid item>
                            <CustomBox component="div" mt={2}>
                                {getRBAC_WOL_View &&
                                    getRBAC_WOL_View.isAccessible === EntityAccess.ALLOWED ? (
                                    <>
                                        {isApi || isApiFailed || !praisoScore ? (
                                            <CustomTypography
                                                className={classes.viewDetailLinkDisabled}
                                                component="span"
                                            >
                                                {t("VIEW_DETAILS")}
                                            </CustomTypography>
                                        ) : (
                                            <CustomLink
                                                className={classes.viewDetailLink}
                                                href={params.impersonationid ? `/impersonation/${params.impersonationid}/walloflegends` : "/walloflegends"}
                                            >
                                                {t("VIEW_DETAILS")}
                                            </CustomLink>
                                        )}
                                    </>
                                ) : null}
                            </CustomBox>
                        </CustomGrid>
                    </CustomGrid>
                </CustomCardContent>
            </CustomCard>
        </CustomPaper>
    );
}
